import { Category } from './types';
import {
  SYSTEM_TOOLS_SUBS,
  FILE_TOOLS_SUBS,
  INTERNET_TOOLS_SUBS,
  SOCIAL_TOOLS_SUBS,
  TEXT_TOOLS_SUBS,
  GAMING_TOOLS_SUBS,
  IMAGE_TOOLS_SUBS,
  VIDEO_TOOLS_SUBS,
  AUDIO_TOOLS_SUBS,
  EDUCATIONAL_TOOLS_SUBS,
  DEVELOPER_TOOLS_SUBS,
  MEDIA_SUBS,
  AI_SUBS,
  DOWNLOADING_SUBS,
  EDUCATIONAL_SUBS,
  MOBILE_SUBS,
  DESKTOP_SUBS,
  READING_SUBS,
  GAMING_SUBS,
  PRIVACY_SECURITY_SUBS,
  AUDIO_SUBS,
  NON_ENGLISH_SUBS,
  MISCELLANEOUS_SUBS,
  UNCATEGORISED_SUBS,
} from './subcategories';

export const CATEGORIES: Category[] = [
  {
    id: 'media',
    titleKey: 'LandingPage.Categories.items.media.title',
    navKey: 'Navigation.items.media',
    subtitleKey: 'LandingPage.Categories.items.media.description',
    icon: 'movie',
    path: '/media',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(MEDIA_SUBS),
  },
  {
    id: 'ai',
    titleKey: 'LandingPage.Categories.items.ai.title',
    navKey: 'Navigation.items.ai',
    subtitleKey: 'LandingPage.Categories.items.ai.description',
    icon: 'psychology',
    path: '/ai',
    isFeatured: true,
    section: 'information_library',
    subcategories: Object.values(AI_SUBS),
  },
  {
    id: 'downloading',
    titleKey: 'LandingPage.Categories.items.downloading.title',
    navKey: 'Navigation.items.downloading',
    subtitleKey: 'LandingPage.Categories.items.downloading.description',
    icon: 'download_for_offline',
    path: '/downloading',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(DOWNLOADING_SUBS),
  },
  {
    id: 'educational',
    titleKey: 'LandingPage.Categories.items.educational.title',
    navKey: 'Navigation.items.educational',
    subtitleKey: 'LandingPage.Categories.items.educational.description',
    icon: 'school',
    path: '/educational',
    isFeatured: true,
    section: 'information_library',
    subcategories: Object.values(EDUCATIONAL_SUBS),
  },
  {
    id: 'mobile',
    titleKey: 'LandingPage.Categories.items.mobile.title',
    navKey: 'Navigation.items.mobile',
    subtitleKey: 'LandingPage.Categories.items.mobile.description',
    icon: 'smartphone',
    path: '/mobile',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(MOBILE_SUBS),
  },
  {
    id: 'desktop',
    titleKey: 'LandingPage.Categories.items.desktop.title',
    navKey: 'Navigation.items.desktop',
    subtitleKey: 'LandingPage.Categories.items.desktop.description',
    icon: 'desktop_windows',
    path: '/desktop',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(DESKTOP_SUBS),
  },
  {
    id: 'reading',
    titleKey: 'LandingPage.Categories.items.reading.title',
    navKey: 'Navigation.items.reading',
    subtitleKey: 'LandingPage.Categories.items.reading.description',
    icon: 'library_books',
    path: '/reading',
    isFeatured: true,
    section: 'information_library',
    subcategories: Object.values(READING_SUBS),
  },
  {
    id: 'gaming',
    titleKey: 'LandingPage.Categories.items.gaming.title',
    navKey: 'Navigation.items.gaming',
    subtitleKey: 'LandingPage.Categories.items.gaming.description',
    icon: 'sports_esports',
    path: '/gaming',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(GAMING_SUBS),
  },
  {
    id: 'privacy-security',
    titleKey: 'LandingPage.Categories.items.privacy.title',
    navKey: 'Navigation.items.privacy',
    subtitleKey: 'LandingPage.Categories.items.privacy.description',
    icon: 'admin_panel_settings',
    path: '/privacy-security',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(PRIVACY_SECURITY_SUBS),
  },
  {
    id: 'audio',
    titleKey: 'LandingPage.Categories.items.audio.title',
    navKey: 'Navigation.items.audio',
    subtitleKey: 'LandingPage.Categories.items.audio.description',
    icon: 'podcasts',
    path: '/audio',
    isFeatured: true,
    section: 'information_library',
    subcategories: Object.values(AUDIO_SUBS),
  },
  {
    id: 'non-english',
    titleKey: 'LandingPage.Categories.items.non-english.title',
    navKey: 'Navigation.items.non-english',
    subtitleKey: 'LandingPage.Categories.items.non-english.description',
    icon: 'translate',
    path: '/non-english',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(NON_ENGLISH_SUBS),
  },
  {
    id: 'miscellaneous',
    titleKey: 'LandingPage.Categories.items.miscellaneous.title',
    navKey: 'Navigation.items.miscellaneous',
    subtitleKey: 'LandingPage.Categories.items.miscellaneous.description',
    icon: 'category',
    path: '/miscellaneous',
    isFeatured: false,
    section: 'information_library',
    subcategories: Object.values(MISCELLANEOUS_SUBS),
  },

  {
    id: 'system-tools',
    titleKey: 'LandingPage.Categories.items.system-tools.title',
    navKey: 'Navigation.items.system-tools',
    subtitleKey: 'LandingPage.Categories.items.system-tools.description',
    icon: 'settings_suggest',
    path: '/system-tools',
    isFeatured: true,
    section: 'information_tools',
    subcategories: Object.values(SYSTEM_TOOLS_SUBS),
  },
  {
    id: 'file-tools',
    titleKey: 'LandingPage.Categories.items.file-tools.title',
    navKey: 'Navigation.items.file-tools',
    subtitleKey: 'LandingPage.Categories.items.file-tools.description',
    icon: 'folder_zip',
    path: '/file-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(FILE_TOOLS_SUBS),
  },
  {
    id: 'internet-tools',
    titleKey: 'LandingPage.Categories.items.internet-tools.title',
    navKey: 'Navigation.items.internet-tools',
    subtitleKey: 'LandingPage.Categories.items.internet-tools.description',
    icon: 'language',
    path: '/internet-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(INTERNET_TOOLS_SUBS),
  },
  {
    id: 'social-tools',
    titleKey: 'LandingPage.Categories.items.social-tools.title',
    navKey: 'Navigation.items.social-tools',
    subtitleKey: 'LandingPage.Categories.items.social-tools.description',
    icon: 'groups',
    path: '/social-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(SOCIAL_TOOLS_SUBS),
  },
  {
    id: 'text-tools',
    titleKey: 'LandingPage.Categories.items.text-tools.title',
    navKey: 'Navigation.items.text-tools',
    subtitleKey: 'LandingPage.Categories.items.text-tools.description',
    icon: 'text_fields',
    path: '/text-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(TEXT_TOOLS_SUBS),
  },
  {
    id: 'gaming-tools',
    titleKey: 'LandingPage.Categories.items.gaming-tools.title',
    navKey: 'Navigation.items.gaming-tools',
    subtitleKey: 'LandingPage.Categories.items.gaming-tools.description',
    icon: 'sports_esports',
    path: '/gaming-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(GAMING_TOOLS_SUBS),
  },
  {
    id: 'image-tools',
    titleKey: 'LandingPage.Categories.items.image-tools.title',
    navKey: 'Navigation.items.image-tools',
    subtitleKey: 'LandingPage.Categories.items.image-tools.description',
    icon: 'image',
    path: '/image-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(IMAGE_TOOLS_SUBS),
  },
  {
    id: 'video-tools',
    titleKey: 'LandingPage.Categories.items.video-tools.title',
    navKey: 'Navigation.items.video-tools',
    subtitleKey: 'LandingPage.Categories.items.video-tools.description',
    icon: 'video_library',
    path: '/video-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(VIDEO_TOOLS_SUBS),
  },
  {
    id: 'audio-tools',
    titleKey: 'LandingPage.Categories.items.audio-tools.title',
    navKey: 'Navigation.items.audio-tools',
    subtitleKey: 'LandingPage.Categories.items.audio-tools.description',
    icon: 'headphones',
    path: '/audio-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(AUDIO_TOOLS_SUBS),
  },
  {
    id: 'educational-tools',
    titleKey: 'LandingPage.Categories.items.educational-tools.title',
    navKey: 'Navigation.items.educational-tools',
    subtitleKey: 'LandingPage.Categories.items.educational-tools.description',
    icon: 'school',
    path: '/educational-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(EDUCATIONAL_TOOLS_SUBS),
  },
  {
    id: 'developer-tools',
    titleKey: 'LandingPage.Categories.items.developer-tools.title',
    navKey: 'Navigation.items.developer-tools',
    subtitleKey: 'LandingPage.Categories.items.developer-tools.description',
    icon: 'terminal',
    path: '/developer-tools',
    isFeatured: false,
    section: 'information_tools',
    subcategories: Object.values(DEVELOPER_TOOLS_SUBS),
  },
  {
    id: 'uncategorised',
    titleKey: 'LandingPage.Categories.items.uncategorised.title',
    navKey: 'Navigation.items.uncategorised',
    subtitleKey: 'LandingPage.Categories.items.uncategorised.description',
    icon: 'folder_open',
    path: '/uncategorised',
    isFeatured: false,
    section: 'more',
    subcategories: Object.values(UNCATEGORISED_SUBS),
  },
];
